<h2 mat-dialog-title class="flo-disc__title">Aviso de Isenção de Responsabilidade</h2>

<mat-dialog-content class="flo-disc__content">
	<section>
		<h3>1. Natureza Informativa e Uso da Inteligência Artificial</h3>
		<p>Este assistente virtual utiliza Inteligência Artificial para fornecer respostas rápidas a partir de uma base de dados selecionada e atualizada pelo administrador do aplicativo, utilizando fontes de mercado e a legislação vigente da <strong>NR-1</strong>.</p>
		<p class="flo-disc__warn">⚠️ <strong>Importante:</strong> As respostas geradas têm caráter <strong>estritamente informativo e educativo</strong>. Este módulo não substitui a consulta formal a engenheiros de segurança, médicos do trabalho, técnicos de SST ou consultorias jurídicas especializadas.</p>
	</section>

	<section>
		<h3>2. Limitação de Responsabilidade</h3>
		<p>Embora façamos o máximo esforço para garantir a precisão e a curadoria das fontes de dados, a Inteligência Artificial pode gerar interpretações automatizadas. A tomada de decisões estratégicas, elaboração de PGR (Programa de Gerenciamento de Riscos), GRO ou implementação de medidas de segurança baseadas exclusivamente nas respostas deste chat é de inteira responsabilidade do usuário.</p>
	</section>

	<section>
		<h3>3. Privacidade e Segurança dos Dados</h3>
		<p>Para sua total tranquilidade e em conformidade com as boas práticas de proteção de dados:</p>
		<ul>
			<li><strong>Armazenamento Seguro:</strong> O histórico de perguntas e respostas é armazenado exclusivamente em nosso banco de dados interno e seguro.</li>
			<li><strong>Sem Compartilhamento Externo:</strong> Os seus dados e interações <strong>não</strong> são compartilhados com terceiros, nem são utilizados para treinar modelos públicos de IA de outras empresas.</li>
		</ul>
	</section>
</mat-dialog-content>

<mat-dialog-actions class="flo-disc__actions">
	<mat-checkbox [checked]="acknowledged()" (change)="acknowledged.set($event.checked)">
		Li e estou ciente das informações acima.
	</mat-checkbox>
	<button mat-flat-button color="primary" [disabled]="!acknowledged()" (click)="accept()">Continuar</button>
</mat-dialog-actions>
